export const NO_CALIBRATION = { buy: { factor: 1, trades: 0 }, sell: { factor: 1, trades: 0 }, items: {}, trades: 0 };
const PRIOR_TRADES = 5, ITEM_PRIOR = 3, MIN_RATIO = 0.1, MAX_RATIO = 30;
/** Actual / predicted hours for each side of each usable trade. */
export function sideRatios(trades) {
    const out = [];
    const clamp = (r) => Math.min(MAX_RATIO, Math.max(MIN_RATIO, r));
    for (const t of trades) {
        const e = t.expected;
        if (!(e.buyH && e.buyH > 0) || !(e.sellH && e.sellH > 0))
            continue;
        const end = t.closedAt;
        if (t.boughtAt != null)
            out.push({ item: t.item, side: "buy", ratio: clamp((t.boughtAt - t.openedAt) / 3.6e6 / e.buyH) });
        else if (t.phase === "expired" && end != null)
            out.push({ item: t.item, side: "buy", ratio: clamp((end - t.openedAt) / 3.6e6 / e.buyH) }); // never bought out: at least this long
        if (t.boughtAt != null && end != null && (t.phase === "done" || t.phase === "expired")) {
            // sell time for the units bought: a partly bought trade sells fewer, so its prediction scales with them
            const sellH = e.sellH * (t.bought / Math.max(1, t.qty));
            if (sellH > 0)
                out.push({ item: t.item, side: "sell", ratio: clamp((end - t.boughtAt) / 3.6e6 / sellH) });
        }
    }
    return out;
}
export function calibrate(trades) {
    const r = sideRatios(trades);
    if (!r.length)
        return NO_CALIBRATION;
    const side = (s) => {
        const xs = r.filter(x => x.side === s);
        return { factor: Math.exp(xs.reduce((a, x) => a + Math.log(x.ratio), 0) / (xs.length + PRIOR_TRADES)), trades: xs.length };
    };
    const buy = side("buy"), sell = side("sell");
    const items = {};
    for (const id of new Set(r.map(x => x.item))) {
        for (const s of ["buy", "sell"]) {
            const xs = r.filter(x => x.item === id && x.side === s);
            if (!xs.length)
                continue;
            const base = Math.log((s === "buy" ? buy : sell).factor);
            (items[id] ??= {})[s] = { factor: Math.exp((xs.reduce((a, x) => a + Math.log(x.ratio), 0) + ITEM_PRIOR * base) / (xs.length + ITEM_PRIOR)), trades: xs.length };
        }
    }
    return { buy, sell, items, trades: trades.filter(t => t.expected.buyH != null && t.expected.sellH != null && t.closedAt != null).length };
}
/** How many times longer than the model this item's orders take on one side (1 = as predicted). */
export const fillFactor = (c, item, side) => c ? (c.items[item]?.[side] ?? c[side]).factor : 1;
//# sourceMappingURL=calibration.js.map